import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}


// Disable browser scroll restoration on web to avoid race with app scroll logic
try {
  if ('scrollRestoration' in history) {
    (history as any).scrollRestoration = 'manual';
  }
} catch {}
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));

